import React from 'react';
import {
  Dialog,
  IconButton,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const AuthModal = ({ open, onClose, initialMode = 'login' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth={isMobile}
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          boxShadow: 'none',
          p: 0,
          m: isMobile ? 0 : 2,
          bgcolor: 'transparent',
          overflow: 'visible',
          maxHeight: isMobile ? '100%' : 'calc(100vh - 64px)',
        }
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          backdropFilter: 'none'
        }
      }}
      sx={{
        '& .MuiDialog-container': {
          alignItems: isMobile ? 'flex-start' : 'center',
        }
      }}
    >
      <Box 
        sx={{ 
          position: 'relative',
          width: '100%',
          maxHeight: isMobile ? '100vh' : 'auto',
          overflowY: 'auto',
          p: isMobile ? 2 : 0,
          pt: isMobile ? 6 : 0, // Extra top padding on mobile for close button
        }}
      >
        {/* Close Button */}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: isMobile ? 'fixed' : 'absolute',
            right: isMobile ? 16 : 16,
            top: isMobile ? 16 : 16,
            color: (theme) => theme.palette.mode === 'dark' 
              ? 'rgba(255,255,255,0.7)' 
              : 'rgba(0,0,0,0.5)',
            bgcolor: (theme) => theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.1)'
              : 'rgba(255,255,255,0.9)',
            backdropFilter: 'none',
            zIndex: 1100,
            width: 40,
            height: 40,
            '&:hover': {
              bgcolor: (theme) => theme.palette.mode === 'dark'
                ? 'rgba(255,255,255,0.2)'
                : 'rgba(255,255,255,1)',
              color: 'primary.main',
              transform: 'rotate(90deg)',
            },
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}
        >
          <CloseIcon />
        </IconButton>
        
        {initialMode === 'login' ? (
          <LoginForm 
            onClose={onClose}
          />
        ) : (
          <RegisterForm 
            onClose={onClose}
          />
        )}
      </Box>
    </Dialog>
  );
};

export default AuthModal;